module.exports = __webpack_public_path__ + "img/moren.a0e527b2.png";